module.exports = __webpack_public_path__ + "static/media/perm.97e6e698.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Offices/img/perm.png
// module id = 806
// module chunks = 0